module.exports = __webpack_public_path__ + "static/media/eye_turquoise.24c2804b.svg";